import React from 'react'
import OxfordInstructions from './OxfordInstructions'

export default (props) => (
    <>
        <h3>Anglais</h3>
        <ul>
            <li>
                <h4> Oxford Online Placement Test</h4>
                <OxfordInstructions {...props} />
            </li>
            <li>
                <h4>Profil linguistique</h4>
                <p>
                    Remplir le{' '}
                    <a href="https://lingo-log.heig-vd.ch/en" target="_blank" rel="noopener noreferrer">
                        formulaire de profil linguistique
                    </a>{' '}
                    dans la langue cible et non en français (dernier délai : 30 juin)
                </p>
            </li>
        </ul>
    </>
)
